module.exports = __webpack_public_path__ + "img/onboarding_delivery_key_en.8779686a.png";